import { removeAssignment as removeAssignmentAPI } from "../api";

export const removeAssignmentAction = async (classID, assignmentID, setClass) => {
  const classroom = await removeAssignmentAPI(classID, assignmentID);
  setClass(classroom.data)
};
